import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const DollarBillIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1 4.25C1 3.55964 1.55964 3 2.25 3H13.75C14.4404 3 15 3.55964 15 4.25V11.75C15 12.4404 14.4404 13 13.75 13H2.25C1.55964 13 1 12.4404 1 11.75V4.25ZM2.5 9.03023V6.96977C3.35337 6.81302 4 6.06536 4 5.16667V4.5H12V5.16667C12 6.06536 12.6466 6.81302 13.5 6.96977V9.03023C12.6466 9.18698 12 9.93464 12 10.8333V11.5H4V10.8333C4 9.93464 3.35337 9.18698 2.5 9.03023Z"
		></path>
	</svg>
))
